import { LOGO_URL, fmtDate } from "@/lib/api";

export default function PackingSlip({ invoice, notes }) {
  if (!invoice) return null;
  const co = invoice.company_details || {};

  return (
    <div className="bg-white p-6 sm:p-8" data-testid="delivery-note">
      <div className="flex justify-between items-start pb-4 border-b-2" style={{ borderColor: "#032352" }}>
        <div className="max-w-xs">
          <img src={LOGO_URL} crossOrigin="anonymous" alt="J&L" className="h-16 object-contain mb-2" />
          <div className="text-xs text-[#5B5C5F] leading-relaxed">
            <p className="font-semibold text-[#032352] text-sm">{co.name || "J&L Industrial Supplies"}</p>
            {co.address && <p className="whitespace-pre-line">{co.address}</p>}
            {co.phone && <p>Tel: {co.phone}</p>}
          </div>
        </div>
        <div className="text-right">
          <h2 className="font-heading text-2xl font-extrabold text-[#032352]">DELIVERY NOTE</h2>
          <p className="font-mono-num text-[#5B5C5F] mt-1">{invoice.invoice_number}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 py-6">
        <div>
          <p className="text-xs uppercase tracking-wider text-[#5B5C5F] mb-2">Deliver To</p>
          <p className="font-semibold text-[#032352]">{invoice.customer_name}</p>
          {invoice.customer_address && (
            <p className="text-sm text-[#5B5C5F] whitespace-pre-line">{invoice.customer_address}</p>
          )}
          {invoice.customer_phone && <p className="text-sm text-[#5B5C5F]">{invoice.customer_phone}</p>}
        </div>
        <div className="text-right space-y-1">
          <div className="flex justify-between gap-8">
            <span className="text-xs uppercase tracking-wider text-[#5B5C5F]">Date</span>
            <span className="text-sm font-medium text-[#032352]">{fmtDate(invoice.invoice_date)}</span>
          </div>
          {invoice.order_number && (
            <div className="flex justify-between gap-8">
              <span className="text-xs uppercase tracking-wider text-[#5B5C5F]">Order No</span>
              <span className="text-sm font-medium text-[#032352]">{invoice.order_number}</span>
            </div>
          )}
        </div>
      </div>

      <table className="w-full text-sm">
        <thead>
          <tr style={{ backgroundColor: "#032352" }} className="text-white">
            <th className="p-3 text-center font-medium w-16">Picked</th>
            <th className="p-3 text-left font-medium">Description</th>
            <th className="p-3 text-center font-medium w-24">Qty</th>
          </tr>
        </thead>
        <tbody>
          {invoice.line_items.map((it, i) => (
            <tr key={i} className="border-b border-slate-200">
              <td className="p-3 text-center">
                <span
                  className="inline-block w-5 h-5 border-2 rounded-sm"
                  style={{ borderColor: "#5B5C5F" }}
                />
              </td>
              <td className="p-3 text-[#032352]">
                {it.title}
                {it.variant ? <span className="text-[#5B5C5F]"> — {it.variant}</span> : null}
              </td>
              <td className="p-3 text-center font-mono-num text-[#032352] font-semibold">{it.quantity}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-8 pt-4 border-t border-slate-200">
        <p className="text-xs uppercase tracking-wider text-[#5B5C5F] mb-1">Notes</p>
        <p className="text-sm text-[#032352] whitespace-pre-line min-h-[3rem]">
          {notes || "—"}
        </p>
      </div>

      <div className="mt-8 border-t-2 pt-6 space-y-6" style={{ borderColor: "#032352" }}>
        <p className="text-xs uppercase tracking-wider font-semibold text-[#032352] mb-4">Received By</p>
        <div className="space-y-5">
          <div>
            <p className="text-xs uppercase tracking-wider text-[#5B5C5F] mb-3">Date</p>
            <div className="border-b-2 border-slate-300 w-64" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-[#5B5C5F] mb-3">Print Name</p>
            <div className="border-b-2 border-slate-300 w-full" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider text-[#5B5C5F] mb-3">Signature</p>
            <div className="border-b-2 border-slate-300 w-full mt-10" />
          </div>
        </div>
      </div>
    </div>
  );
}
